import { useEffect, useState } from "react";
import { useBelaChat } from "./BelaChatContext";
import "./BelAiChat.css";

const TIP_MESSAGES = [
  "Bela is here to help you",
  "Need support? Just ask",
  "Chat with Bela",
];

/**
 * Floating Bela launcher — same pattern as belpower-frontend BelAiChat.
 */
export default function BelAiChat() {
  const { isOpen, openChatBot } = useBelaChat();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showText, setShowText] = useState(true);

  useEffect(() => {
    let hideTimeout;
    let switchTimeout;

    if (showText) {
      hideTimeout = setTimeout(() => setShowText(false), 3000);
    } else {
      switchTimeout = setTimeout(() => {
        setCurrentIndex((prev) =>
          prev === TIP_MESSAGES.length - 1 ? 0 : prev + 1
        );
        setShowText(true);
      }, 120000);
    }

    return () => {
      clearTimeout(hideTimeout);
      clearTimeout(switchTimeout);
    };
  }, [showText]);

  if (isOpen) return null;

  return (
    <div className="chat_support">
      <div
        className="support_card"
        style={{ opacity: showText ? 1 : 0 }}
        aria-hidden={!showText}
      >
        <p>{TIP_MESSAGES[currentIndex]}</p>
      </div>

      <div className="relative">
        <button
          type="button"
          data-bel-chat-launcher
          onClick={openChatBot}
          title="Open BelAI Chat"
          aria-label="Open BelAI Chat Assistant"
          className="bela-chat-launcher"
        >
          <div className="bela-image-container">
            <img src="/Bela.png" alt="Bela" width={48} height={48} />
          </div>
        </button>
      </div>
    </div>
  );
}
